/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CardHashInfo } from '../models/CardHashInfo';
import type { CardInfo } from '../models/CardInfo';
import type { CreateClaimWithCaptchaParams } from '../models/CreateClaimWithCaptchaParams';
import type { ListResponse_SelectIntItem_ } from '../models/ListResponse_SelectIntItem_';
import type { ListResponse_SelectItem_ } from '../models/ListResponse_SelectItem_';
import { request as __request } from '../core/request';

export class ClaimsService {

    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static async create(
        requestBody: CreateClaimWithCaptchaParams,
    ): Promise<void> {
        const result = await __request({
            method: 'POST',
            path: `/claims/create`,
            body: requestBody,
            errors: {
                400: `Validation Failed`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static async resendCard(
        requestBody: CardHashInfo,
    ): Promise<void> {
        const result = await __request({
            method: 'POST',
            path: `/claims/cards/resend`,
            body: requestBody,
            errors: {
                400: `Validation Failed`,
                401: `Введенный номер карты не соответствует номеру карты в системе`,
                403: `Карта не найдена`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param bskNum
     * @returns CardInfo Ok
     * @throws ApiError
     */
    public static async getCardToEditInfo(
        bskNum: string,
    ): Promise<CardInfo> {
        const result = await __request({
            method: 'GET',
            path: `/claims/edit`,
            query: {
                'bskNum': bskNum,
            },
            errors: {
                400: `Validation Failed`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @returns ListResponse_SelectItem_ Ok
     * @throws ApiError
     */
    public static async getVisibleDocsType(): Promise<ListResponse_SelectItem_> {
        const result = await __request({
            method: 'GET',
            path: `/claims/visibleDocsType`,
            errors: {
                400: `Validation Failed`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @returns ListResponse_SelectIntItem_ Ok
     * @throws ApiError
     */
    public static async getCitizenTypeList(): Promise<ListResponse_SelectIntItem_> {
        const result = await __request({
            method: 'GET',
            path: `/claims/citizenTypeList`,
            errors: {
                400: `Validation Failed`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param qrData
     * @returns string Ok
     * @throws ApiError
     */
    public static async getCardQr(
        qrData: string,
    ): Promise<string> {
        const result = await __request({
            method: 'GET',
            path: `/claims/cardQr`,
            query: {
                'qrData': qrData,
            },
            errors: {
                400: `Validation Failed`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

}